// DON't CHANGE!
// automated by SVGR script
import * as React from "react";
const RefreshIcon = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20",
  "aria-hidden": "true",
  "data-icon": "Refresh/solid"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M4 2a1 1 0 0 1 1 1v2.101a7.003 7.003 0 0 1 11.601 2.566 1 1 0 0 1-1.885.666A5.003 5.003 0 0 0 5.999 7H9a1 1 0 0 1 0 2H4a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1Zm.008 9.057a1 1 0 0 1 1.276.61A5.002 5.002 0 0 0 14.001 13h-3a1 1 0 1 1 0-2h5a1 1 0 0 1 1 1v5a1 1 0 1 1-2 0v-2.101A7.002 7.002 0 0 1 3.4 12.333a1 1 0 0 1 .608-1.276Z",
  clipRule: "evenodd"
}));
export default RefreshIcon;